import { addDays, format } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

/**
 * 프로모션 스케줄의 모든 날짜 계산은 **KST 고정**이다.
 *
 * 브라우저 시간대를 쓰면 해외 출장 중 접속한 사람에게 다른 화면이 보인다 —
 * `2026-08-20T15:00:00Z` 는 KST 로 8/21 이지만 미국 시간대에서는 8/20 이라
 * 간트 열 배치·주차 배정·"종일 여부" 판정이 접속 위치에 따라 갈린다.
 * 기획 업무의 기준 시간대가 KST 이고 백엔드도 `timezone: '+09:00'` 고정이라
 * 화면만 로컬을 따르면 저장값과 표시가 어긋난다.
 *
 * KST 는 서머타임이 없어 오프셋이 항상 +09:00 이므로 날짜 덧셈이 시각을 흔들지 않는다.
 */
export const KST_TIME_ZONE = 'Asia/Seoul';

/** ISO 문자열 → KST wall-clock 을 담은 Date (표시·판정용. UTC 시점이 아니다) */
export const toKstDate = (value: string): Date => utcToZonedTime(new Date(value), KST_TIME_ZONE);

/** ISO 문자열을 KST 기준으로 포맷한다 */
export const formatKst = (value: string, pattern: string): string => format(toKstDate(value), pattern);

/**
 * KST wall-clock 문자열(`yyyy-MM-dd HH:mm:ss`) → UTC ISO.
 * 문자열로 받는 이유 — `Date` 를 넘기면 그 객체의 로컬 필드를 wall-clock 으로 읽어
 * 브라우저 시간대가 다시 섞인다.
 */
export const kstWallClockToIso = (wallClock: string): string => zonedTimeToUtc(wallClock, KST_TIME_ZONE).toISOString();

/**
 * KST 기준으로 일수를 더한다. **시각은 보존한다** —
 * 14시 시작 타임딜을 이틀 뒤로 끌면 여전히 KST 14시 시작이어야 한다.
 */
export const shiftIsoByKstDays = (value: string, days: number): string => {
  const shifted = addDays(toKstDate(value), days);

  return kstWallClockToIso(format(shifted, 'yyyy-MM-dd HH:mm:ss'));
};

/** KST 기준 오늘 (`yyyy-MM-dd`). "오늘" 강조·기본 조회 범위가 접속 위치에 흔들리지 않게 한다. */
export const getTodayKst = (): string => format(toKstDate(new Date().toISOString()), 'yyyy-MM-dd');
